/**
 * Init all Components for Shop
 */

import * as utils from "@sharedJS/utils";
import * as resize from "@sharedJS/resize";
import * as formElements from "@sharedJS/formElements";
import * as categoryBar from "@sharedJS/categoryBar";
import * as accordion from "@sharedJS/accordion";
import * as accordionNavigation from "@sharedJS/accordionNavigation";
import * as headerNavigation from "@sharedJS/headerNavigation";
import * as scrollbar from "@sharedJS/scrollbar";
import * as popUpOverlay from "@sharedJS/popUpOverlay";
import * as offcanvas from "@sharedJS/offcanvas";
import * as clearSearch from "@sharedJS/clearSearch";
import * as tooltip from "@sharedJS/tooltip";
import * as infoModals from "@sharedJS/infoModals";
import * as dropdown from "@sharedJS/dropdown";
import * as socialButtons from "@sharedJS/socialButtons";
import * as slider from "@sharedJS/slider";
import * as gotop from "@sharedJS/gotop";
import * as gotopbuttonInsert from "@sharedJS/gotopbuttonInsert";
import * as responsiveHeight from "@sharedJS/responsiveHeight";
import * as loader from "@shopJS/loader";
import * as preventClick from "@sharedJS/preventClick";

import landingPage from "@sharedJS/landingpage";

import * as forgottenPassword from "@sharedJS/forgottenPassword";
import * as forgottenPasswordConfirm from "@sharedJS/forgottenPasswordConfirm";
import * as slot from "@sharedJS/slot";
import header from "@sharedJS/header";
import * as flyout from "@sharedJS/flyout";
import commonPopupTrigger from "@JS/shop/10-login-component/commonPopupTrigger";
import * as loyaltyMigration from "@sharedJS/loyaltyMigration";

import * as wishlistCount from "@shopJS/wishlistCount";

import * as teaserHeaderAddbrand from "@sharedJS/teaserHeaderAddbrand";
import * as teaserHeaderMore from "@sharedJS/teaserHeaderMore";
import checkout from "@shopJS/checkout";
import * as checkoutAddressForms from "@shopJS/checkoutAddressForms";
import * as checkoutAddressDelete from "@shopJS/checkoutAddressDelete";
import * as checkoutPayment from "@shopJS/checkoutPayment";
import * as checkoutFinish from "@shopJS/checkoutFinish";

import * as cart from "@shopJS/cart";
import * as coupon from "@shopJS/coupon";
import * as popupMessagesLayer from "@sharedJS/popupMessagesLayer";
import * as previewCountryFlyout from "@shopJS/previewCountryFlyout";
import * as contactForm from "@sharedJS/contactForm";
import * as faqAnchor from "@sharedJS/faqAnchor";
import * as faqAccordion from "@sharedJS/faqAccordion";
import * as brandListMenu from "@sharedJS/brandListMenu";
import inspirationOverview from "@shopJS/inspirationOverview";
import * as scrollToLabel from "@sharedJS/scrollToLabel";
import * as returnSummary from "@shopJS/return";
import * as toggleSubmitButton from "@sharedJS/toggleSubmitButton";
import * as returnOrderDHLFunction from "@shopJS/accountOrderHistory";

import * as loginFacebook from "@sharedJS/loginFacebook";
import * as loginGoogle from "@sharedJS/loginGoogle";
import * as loginAndRegister from "@sharedJS/loginAndRegister";
import * as registerConfirmation from "@sharedJS/registerConfirmation";
import * as dateMaskField from "@sharedJS/dateMaskField";

import { initAjaxPrefilter } from "@sharedJS/ajaxprefilter";
import * as brandteaser from "@sharedJS/brandteaser";
import * as modal from "@sharedJS/modal"; //
import * as logoAnimation from "@sharedJS/logoAnimation";
import * as loginHintBanner from "@sharedJS/loginHintBanner";
import * as lazyLoader from "@sharedJS/lazyLoader";
import * as seoLinkMask from "@sharedJS/seoLinkMask";

import * as clipboard from "@sharedJS/clipboard";
import * as epoqForeignInit from "@shopJS/epoqForeignInit";
import * as epoqCartData from "@shopJS/epoqCartData";
import * as svgIcons from "@sharedJS/svgIcons";

import * as ios14TabHighlightPrevention from "@sharedJS/ios14TabHighlightPrevention";

// General
initAjaxPrefilter();
utils.init();
resize.init();
formElements.init();
categoryBar.init();
accordion.init();
accordionNavigation.init();
headerNavigation.init();
scrollbar.init();
scrollbar.scrollbarAccordionInit();
popUpOverlay.init();
offcanvas.init();
clearSearch.init();
tooltip.init();
infoModals.init();

dropdown.init();
socialButtons.init();
slider.init();
gotop.init();
gotopbuttonInsert.init();
responsiveHeight.init();
loader.init();
preventClick.init();

landingPage.init();

// Login/Registration, Welcome-Layer
commonPopupTrigger.init(); //

//Accept Loyalty Terms and Conditions
loyaltyMigration.init();

// Password forgotten
forgottenPassword.init();
forgottenPasswordConfirm.init();
// // Department Home
slot.init();

// Header
header.init();
flyout.init();

// Wishlist
wishlistCount.init();

// Category
teaserHeaderMore.init();
teaserHeaderAddbrand.init();

// Checkout
checkout.init();
checkoutAddressForms.init();
checkoutAddressDelete.init();
checkoutPayment.init();
checkoutFinish.init();

// Cart
cart.init();
coupon.init();

// Popup Messages Layer
popupMessagesLayer.init();

// Preview
previewCountryFlyout.init();

// Contact form
contactForm.init();

// FAQ
faqAnchor.init();
faqAccordion.init();

// Brand List
brandListMenu.init();

// Inspiration
inspirationOverview.init();

// ScrollToLabel z.B. bei Anzugberater
scrollToLabel.init();

// Digital Retourenschein
returnSummary.init();

// Data accept
toggleSubmitButton.init();

loginFacebook.init();
loginGoogle.init();
loginAndRegister.init();
registerConfirmation.init();

// DateMaskField
dateMaskField.init();

//do we need those?
brandteaser.init();

// button for DHL download in Austrian retour process
returnOrderDHLFunction.init();

logoAnimation.init();
modal.init();
loginHintBanner.init();
lazyLoader.init();

seoLinkMask.init();
clipboard.init();
epoqForeignInit.init();
epoqCartData.init();

// ios14 hack
ios14TabHighlightPrevention.init();
svgIcons.init();
